import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { TEAM } from "@/constants/testIds";

const DAY_NAMES = ["Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado", "Domingo"];

/**
 * Editor de horarios semanales para un profesional.
 * value: array de 7 items { day_of_week, start_time, end_time, is_active }
 */
export default function ScheduleEditor({ value, onChange }) {
  const getDay = (dayIndex) =>
    value.find((d) => d.day_of_week === dayIndex) || { day_of_week: dayIndex, start_time: "09:00", end_time: "18:00", is_active: false };

  const updateDay = (dayIndex, patch) => {
    const existing = getDay(dayIndex);
    const updated = { ...existing, ...patch };
    const others = value.filter((d) => d.day_of_week !== dayIndex);
    onChange([...others, updated].sort((a, b) => a.day_of_week - b.day_of_week));
  };

  return (
    <div className="space-y-2">
      <label className="text-sm text-muted-foreground mb-1 font-sans block">Horarios de atención</label>
      <div className="border border-border rounded-lg divide-y divide-border">
        {DAY_NAMES.map((dayName, idx) => {
          const day = getDay(idx);
          return (
            <div key={idx} className="flex items-center gap-3 px-3 py-2.5 flex-wrap">
              <Switch
                checked={day.is_active}
                onCheckedChange={(checked) => updateDay(idx, { is_active: checked })}
                data-testid={`${TEAM.modalScheduleDayPrefix}${idx}`}
              />
              <span className="text-sm w-24 shrink-0 text-foreground">{dayName}</span>
              <Input
                type="time"
                value={day.start_time}
                onChange={(e) => updateDay(idx, { start_time: e.target.value })}
                disabled={!day.is_active}
                className="w-28"
              />
              <span className="text-muted-foreground text-sm">a</span>
              <Input
                type="time"
                value={day.end_time}
                onChange={(e) => updateDay(idx, { end_time: e.target.value })}
                disabled={!day.is_active}
                className="w-28"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
